export const environment = {
  "production": true,
  "baseUrl": "https://doc-united.cipherpay.in/api/",
  "apiUrlReporting": "https://doc-united.cipherpay.in/api/console/",
  "corporateBaseUrl": "https://doc-united.cipherpay.in/api/corporate/",
  "adminBaseUrl": "https://doc-united.cipherpay.in/api/console/",
  "imgBaseUrl": "https://beta.cipherpay.in/",
  "imgBaseToken": "3fcf0ece92b4e956b4c84e98f11243a7e30639a7",
  "defEncKey": "942831ca4295ca8185be8b99a051bc2d"
}
